export const MAGIC_MEAL_PLANNER_STARTER_PLANS_FEATURE_FLAG = "magicMealPlannerStarterPlans";
export const MMP_CUSTOM_PLAN_LIMIT = 20;

export function isStarterMealPlan(plan) {
  return Boolean(plan?.starterTemplateKey);
}

export function isStarterTemplatePlan(plan) {
  return Boolean(plan?.starterTemplate);
}

export function isStarterPlanCopy(plan) {
  return isStarterMealPlan(plan) && !isStarterTemplatePlan(plan);
}

export function isVisibleStarterMealPlan(plan) {
  return isStarterMealPlan(plan) && (isStarterTemplatePlan(plan) || !Boolean(plan?.starterPlanCustomized));
}

export function customMealPlanCount(plans = []) {
  return plans.filter(plan => !isStarterTemplatePlan(plan)).length;
}

export function canAddCustomMealPlan({plans = [], hiddenPlans = [], member}) {
  return Boolean(member?.admin) || customMealPlanCount([...plans, ...hiddenPlans]) < MMP_CUSTOM_PLAN_LIMIT;
}

export function canManageStarterTemplates(member) {
  return Boolean(member?.admin);
}

export function shouldShowStarterBadge({plan, starterPlansEnabled, isAdmin = false, isPublicPlan = false}) {
  if (isPublicPlan) {
    return false;
  }
  return (isAdmin && Boolean(plan?.starterTemplate)) || (starterPlansEnabled && isVisibleStarterMealPlan(plan));
}

export function starterBadgeLabel() {
  return "Starter Plan";
}

export function starterTemplateDateValue(publishedAt) {
  if (typeof publishedAt === "string") {
    const datePrefix = publishedAt.match(/^\d{4}-\d{2}-\d{2}/);
    return datePrefix ? datePrefix[0] : "";
  }
  if (typeof publishedAt !== "number" || !Number.isFinite(publishedAt)) {
    return "";
  }
  const milliseconds = Math.abs(publishedAt) < 100000000000 ? publishedAt * 1000 : publishedAt;
  const date = new Date(milliseconds);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().substring(0, 10);
}

export function groupMagicMealPlans(plans) {
  return plans.reduce((result, plan) => {
    if (isStarterTemplatePlan(plan)) {
      result.starterPlans.push(plan);
    } else {
      result.customPlans.push(plan);
    }
    return result;
  }, { starterPlans: [], customPlans: [] });
}
